import { render } from "./SavingForm.vue?vue&type=template&id=8ddcc660"
import script from "./SavingForm.vue?vue&type=script&lang=js"
export * from "./SavingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__